import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { DatePicker, Radio, Tooltip } from 'antd';
import 'react-datepicker/dist/react-datepicker.css';
import { Col, Grid, Row } from 'react-flexbox-grid';
import { projectStatusCodeMap } from '../../components/ProjectStatusCodeMap';
import { isCreatorOrAdministrator } from '../../utils/UserInfo';
import Moment from 'moment';
import CommentsIcon from '../../components/CommentsIcon';
import { confirmAlert } from 'react-confirm-alert';
import Alert from '../../components/Alert';
import {
    getPCContractors,
    getPreforms,
    getReasonCodes,
    signedProjectTasks,
    updateProjectCIPRemovalDetails,
    updateProjectDetails,
    updateProjectDetailsHazardousMaterials,
    getProjectsHazardous,
    getProject
} from '../../api';
import { CalendarOutlined } from '@ant-design/icons';
import moment from "moment-timezone";
import { withRouter } from "react-router-dom";
import ProjectReasonDialog from "../../components/ProjectCloseReason";
import BootstrapTable from 'react-bootstrap-table-next';
import ReactTooltip from "react-tooltip";
import MergeUnMergeProcess from "../../components/MergeUnMerge/MergeUnMergeProcess";
import SpinnerNew from "../../components/Spinner/SpinnerNew";
import PCContractorDialog from "../../components/PCContractorDialog";
import dayjs from 'dayjs';
import './checkList.css'
import HazardousSelectionDialog from 'components/HazardousSelectionDialog';
function ProjectDetailsWrapper(props) {
    const { project, history, isEnergizedValue, hazardousMaterialsSelected , setCurrentProject, refreshProject} = props;
    const [tempProject, setTempProject] = useState(project);
    const [removalCheck, setRemovalCheck] = useState(project.showRemovalTasks);
    const [securityCheck, setSecurityCheck] = useState(project.showSecurityTasks);

    const [showStationTeams, setShowStationTeams] = useState(project.showStationTeams);
    const [showStationContractors, setShowStationContractors] = useState(project.showStationContractors);
    const [showStationOfflineForms, setShowStationOfflineForms] = useState(project.showStationOfflineForms);
    const [showPCTeams, setShowPCTeams] = useState(project.showPCTeams);
    const [showPCOfflineForms, setShowPCOfflineForms] = useState(project.showPCOfflineForms);
    const [showNewStations, setShowNewStations] = useState(project.showNewStations);
    const [showHazardousMaterials, setShowHazardousMaterials] = useState(project.showHazardousMaterials);
    const [showAssetHealth, setShowAssetHealth] = useState(project.showAssetHealth);
    const [showDistributionAutomation, setShowDistributionAutomation] = useState(project.showDistributionAutomation);
    const [showDropInControlModule, setShowDropInControlModule] = useState(project.showDropInControlModule);

    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [spinnerOn, setSpinnerOn] = useState(false);
    const [defaultExpectedCloseDate, setDefaultExpectedCloseDate] = useState(dayjs(tempProject.calcECD
    ))

    const [loading, setLoading] = useState(true); // Initialize loading as true 
    const [error, setError] = useState(null);
    const [selectedValueString, setSelectedValueString] = useState(hazardousMaterialsSelected);
    const fetchData = async () => {
        try {
            const response = await getProjectsHazardous(project.id, project.bpid);
            setSelectedValueString(response.hazardousOptions);
        } catch (e) {
            console.log(e)
            setError(e);
        } finally {
            setLoading(false); // Set loading to false when the request finishes (success or error)
        }
    };

    const handleTempProject = useCallback(() => {
    refreshData();
  }, [tempProject]);

    const refreshData = async () => {
        try {
            setSpinnerOn(true);
            const response = await getProject(project.id);
            setCurrentProject(response);
            console.log("Refreshing.....")
        } catch (e) {
            console.log(e)
            setError(e);
        } finally {
            setSpinnerOn(false);
        }
    };

    const initialSelectedArray = useMemo(() => {
        if (selectedValueString == undefined || selectedValueString == null || selectedValueString.length === 0) {
            return project.hazardousSelected || [];
        }
        return selectedValueString;
    }, [selectedValueString, project.hazardousSelected]);

    const [isECDLessThanExpectedCloseDate, setIsECDLessThanExpectedCloseDate] = useState(
        // This condition when user input Expected close date is present and then In-Service date is changed through Ecosys and it less then calc close date 
        (tempProject.expectedCloseDate && (dayjs(tempProject.expectedCloseDate).isBefore(defaultExpectedCloseDate)))

    )

    useEffect(() => {
        setTempProject(project);
        setRemovalCheck(project.showRemovalTasks);
        setSecurityCheck(project.showSecurityTasks);
        setShowStationTeams(project.showStationTeams);
        setShowAssetHealth(project.showAssetHealth);
        setShowDistributionAutomation(project.showDistributionAutomation);
        setShowDropInControlModule(project.showDropInControlModule);
        setShowHazardousMaterials(project.showHazardousMaterials);
        setShowNewStations(project.showNewStations);
        setShowPCOfflineForms(project.showPCOfflineForms);
        setShowPCTeams(project.showPCTeams);
        setShowStationContractors(project.showStationContractors);
        setShowStationOfflineForms(project.showStationOfflineForms);
    }, [props]);


    useEffect(() => {
        setIsECDLessThanExpectedCloseDate((tempProject.expectedCloseDate && (dayjs(tempProject.expectedCloseDate).isBefore(defaultExpectedCloseDate))))
    }, [tempProject])

    useEffect(() => {
        setSpinnerOn(false);
    }, [setCurrentProject])


    const handleSave = async (newValue) => {
        setSelectedValueString(newValue);
        let response = await updateProjectDetailsHazardousMaterials(project, newValue);
        setCurrentProject({...project, ...response.data });
    };

    const columns = [
        {
            dataField: 'stationName',
            text: 'Station Name',
            style: { textAlign: 'left', verticalAlign: 'middle' },
            headerStyle: {
                textAlign: 'left'
            }
        },
        {
            dataField: 'projectDescription',
            text: 'Description',
            style: { textAlign: 'left', verticalAlign: 'middle' },
            headerStyle: {
                textAlign: 'left'
            }
        },
        {
            dataField: 'bpid',
            text: 'BPID',
            style: { textAlign: 'left', verticalAlign: 'middle' },
            headerStyle: {
                textAlign: 'left'
            }
        },
        {
            dataField: 'mpid',
            text: 'MPID',
            style: { textAlign: 'left', verticalAlign: 'middle' },
            headerStyle: {
                textAlign: 'left'
            }
        },
        {
            dataField: 'workOrder',
            text: 'Work Order',
            formatter: workOrderFormater,
            style: { textAlign: 'left', verticalAlign: 'middle' },
            headerStyle: {
                textAlign: 'left'
            }
        },
        {
            dataField: 'constructionStartDate',
            text: 'Construction Start Date',
            style: { textAlign: 'left', verticalAlign: 'middle' },
            headerStyle: {
                textAlign: 'left'
            }
        },
        {
            dataField: 'inServiceDate',
            text: 'In Service Date',
            style: { textAlign: 'left', verticalAlign: 'middle' },
            headerStyle: {
                textAlign: 'left'
            }
        },


        {
            dataField: 'id',
            text: 'Comments',
            formatter: (text, record) => (
                <div style={{ display: 'inline-block' }}>
                    <CommentsIcon project={record} />
                </div>
            ),
            style: { textAlign: 'center', verticalAlign: 'middle' },
            headerStyle: {
                textAlign: 'center'
            }
        }
    ];
    function workOrderFormater(cell, row) {
        let wos = row.workOrder === null ? null : row.workOrder.split(',');
        if (wos === null) {
            return (
                <div />
            )
        }
        if (wos.length < 2) {
            return (
                <>
                    <div>{wos[0]}</div>
                </>
            )
        }
        else if (wos.length === 2) {
            return (
                <>
                    <div>{wos[0]}</div>
                    <div>{wos[1]}</div>
                </>
            )
        }
        else {
            return (
                <>
                    <div>{wos[0]}</div>
                    <div style={{ width: 100 }} data-tip data-for={'toolTip-workorder-' + row.id}>{wos[1]} ...</div>
                    <ReactTooltip id={'toolTip-workorder-' + row.id} place="bottom" effect="solid" textColor='black' backgroundColor='white' border={true} borderColor="black" type="info">
                        {wos.map(item => (
                            <div>{item}</div>
                        ))}
                    </ReactTooltip>
                </>
            )
        }
    }

    {
        return (
            <div className="container-fluid">
                <SpinnerNew display={spinnerOn || refreshProject} />
                <div
                    className="merge-child-table"
                    style={{
                        paddingLeft: '1px',
                        borderWidth: 1,
                        borderColor: "#888",
                        borderStyle: "solid"
                    }}
                >
                    <BootstrapTable keyField='id'
                        data={(project.relatedProjects?.length ?? 0) === 0 ? [project] : project.relatedProjects}

                        columns={columns}
                        striped
                        hover
                        condensed
                    />

                </div>
                <br />
                <Grid fluid>
                    <Row>
                        <Col lg={6} xl={6} md={12} xs={12} style={{ textAlign: 'left' }}>
                            <Row style={{ alignItems: 'center' }} >
                                <Col style={{ marginLeft: '8px' }}><strong>Checklist Release Date:</strong></Col>
                                <Col lg={6} xl={6} md={6} xs={10} style={{ paddingLeft: '10px' }}>
                                    {!isCreatorOrAdministrator() ?
                                        <div>
                                            {tempProject.commisioningStartDate}
                                        </div> :
                                        <DatePicker
                                            autoComplete="off"
                                            id="CommStartDt"
                                            format={'MMMM DD, YYYY'}
                                            suffixIcon={<CalendarOutlined />}
                                            onChange={handleCommissioningStartDateChange}
                                            value={tempProject.commisioningStartDate ? Moment(tempProject.commisioningStartDate) : tempProject.commisioningStartDate}
                                            disabled={(project.projectStatus === projectStatusCodeMap["CLOSED"])}
                                        />
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col style={{ marginLeft: '8px' }}>{tempProject.releaseDateChangedDate ? ('Modified by ' + tempProject.releaseDateChangedBy + ' on ' +
                                    moment(tempProject.releaseDateChangedDate).tz(userTimeZone).format('MM/DD/YYYY h:mm a z')) : ''}</Col>
                            </Row>
                        </Col>
                        <Col lg={6} xl={6} md={12} xs={12} style={{ textAlign: 'left' }}>
                            <Row style={{ alignItems: 'center' }}>
                                <Col style={{ marginLeft: '8px' }}><strong>Expected Close Date:</strong></Col>
                                <Col lg={6} xl={6} md={6} xs={10} style={{ paddingLeft: '10px' }}>
                                    {!isCreatorOrAdministrator() ?
                                        tempProject.defExpectedCloseDate
                                        :
                                        <DatePicker
                                            autoComplete="off"
                                            id="ExpectedCloseDt"
                                            format={'MMMM DD, YYYY'}
                                            suffixIcon={<CalendarOutlined />}
                                            onChange={handleExpectedCloseDateChange}
                                            value={tempProject.defExpectedCloseDate ? Moment(tempProject.defExpectedCloseDate) : tempProject.defExpectedCloseDate}
                                            disabled={(project.projectStatus === projectStatusCodeMap["CLOSED"])}
                                        />
                                    }
                                </Col>
                                <Col>
                                    {(tempProject.expectedCloseDate === null || isECDLessThanExpectedCloseDate) &&
                                        (
                                            <Tooltip title={'Default Value is calculated as the max of In-Service, Energization and Resolution Dates + 45 days'}>
                                                <i className='fa fa-info-circle fa-1x' />
                                            </Tooltip>
                                        )
                                    }
                                </Col>
                            </Row>
                            <Row>
                                {/* <Col  style={{  marginLeft: '8px'}}>{tempProject.expectedCloseChangedDate ?
                            ((tempProject.expectedCloseDate === null ? 'Reset to Default by ' : 'Modified by ') + tempProject.expectedCloseChangedBy + ' on ' +
                                        moment(tempProject.expectedCloseChangedDate).tz(userTimeZone).format('MM/DD/YYYY h:mm a z')) : ''}
                                </Col> */}


                                {(isECDLessThanExpectedCloseDate || tempProject.expectedCloseDate === null) ? <Col style={{ marginLeft: '8px' }}>{
                                    `Reset to Default                   
` }
                                </Col> : <Col style={{ marginLeft: '8px' }}>{tempProject.expectedCloseChangedDate ?
                                    ((tempProject.expectedCloseDate === null ? 'Reset to Default by ' : 'Modified by ') + tempProject.expectedCloseChangedBy + ' on ' +
                                        moment(tempProject.expectedCloseChangedDate).tz(userTimeZone).format('MM/DD/YYYY h:mm a z')) : ''}
                                </Col>}

                            </Row>
                        </Col>
                    </Row>
                </Grid>
                <br />
                <Grid fluid>
                    <Row>
                        <Col lg={6} md={6} xs={6}>
                            <Row>
                                <Col lg={5} md={4} xs={2}>
                                    <b>Station Region:</b>
                                </Col>
                                <Col lg={7} md={4} xs={2}>
                                    {project.stationRegion}
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={5} md={4} xs={2}>
                                    <b>TFS Station Area:</b>
                                </Col>
                                <Col lg={7} md={4} xs={2}>
                                    {project.tfStationArea}
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={5} md={4} xs={2}>
                                    <b>TFS P&C Area:</b>
                                </Col>
                                <Col lg={7} md={4} xs={2}>
                                    {project.pcArea}
                                </Col>
                            </Row>
                        </Col>

                        {tempProject.closeReasonCodes &&
                            <Col xs={5}>
                                <div>
                                    <b>{'Reason: '}</b>{tempProject.closeReasonCodes}
                                </div>
                                {tempProject.closeReasonNotes && <div>
                                    <b>{'Notes: '}</b>{tempProject.closeReasonNotes}
                                </div>}
                            </Col>
                        }
                        {tempProject.closeReasonCodes && (isCreatorOrAdministrator() && project.projectStatus !== "C") &&
                            <Col xs={1}>
                                <button style={{ marginLeft: '20px' }}
                                    className="btn btn-primary start-5"
                                    disabled={!isCreatorOrAdministrator() || (project.projectStatus === "C")}
                                    onClick={() => { handleExpectedCloseDateEdit(null); }}
                                >
                                    Edit
                                </button>
                            </Col>
                        }

                    </Row>
                    
                </Grid>
                <hr />
                <Grid fluid>
                    <Row style={{ marginBottom: '16px' }} middle={"md"}>
                        <Col xs={12}>
                            <b>Select the following Project Task Lists to be included in the Checklist:</b>
                        </Col>
                    </Row>
                    <Row middle={'xs'} style={{ marginBottom: '16px' }}>

                        <Col xs={8}>
                            <div><u>CIP Security:</u></div>
                            <div> - Is this project at a CIP Medium Impact Substation?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'security-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1
                                }, { label: 'No', value: 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C") || (project.cipSelectLock === "Y")}
                                onChange={handleSecurityRadioButtonChange}
                                value={securityCheck} />

                        </Col>
                    </Row>
                    <Row>
                        <Col xs={8}>
                            {(project.cipSelectLock === "Y") &&
                                <div><i className="fa fa-info-circle" style={{ color: 'red', paddingRight: '3px' }}
                                    aria-hidden="true" /><i> Note: CIP Security choice cannot be modified after a Pre-E
                                        Form has been Energized.</i></div>}
                        </Col>
                    </Row>

                    <Row middle={"xs"} style={{ marginBottom: '16px' }} className="question-row-even">
                        <Col xs={8}>
                            <div><u>Removals:</u></div>
                            <div> - Are there any assets being retired during this project?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'removal-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'removal-check'
                                }, { label: 'No', value: 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))}
                                onChange={handleRemovalRadioButtonChange}
                                value={removalCheck} />

                        </Col>

                    </Row>

                    <br />


                </Grid>

                <Grid fluid>
                    <Row style={{ marginBottom: '16px' }} middle={"md"}>
                        <Col xs={12}>
                            <b>Answer the following project questions about the Checklist:</b>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={8}>
                            {((project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))) &&
                                <div><i className="fa fa-info-circle" style={{ color: 'red', paddingRight: '3px' }}
                                    aria-hidden="true" /><i> Note: Form choices cannot be modified after a Pre-E
                                        Form has been Energized.</i></div>}
                        </Col>
                    </Row>
                    <Row middle={"xs"} style={{ marginBottom: '16px' }} className="question-row-even">
                        <Col xs={8}>
                            <div><u>Station Team:</u></div>
                            <div> - Does the scope of the project include any involvement from the Station team?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'removal-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'removal-check',
                                }, { label: 'No', value: 0, disabled: showPCTeams == 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))}
                                onChange={handleShowStationTeamsRadioButtonChange}
                                value={showStationTeams} />

                        </Col>

                    </Row>

                    <Row middle={"xs"} style={{ marginBottom: '16px' }}>
                        <Col xs={8}>
                            <div><u>Station Contractors:</u></div>
                            <div> - Does this project have Station Contractors performing test & checkout activities?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'removal-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'removal-check'
                                }, { label: 'No', value: 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y")) || showStationTeams == 0}
                                onChange={handleShowStationContractorsRadioButtonChange}
                                value={showStationContractors} />

                        </Col>

                    </Row>

                    <Row middle={"xs"} style={{ marginBottom: '16px' }} className="question-row-even">
                        <Col xs={8}>
                            <div><u>Station Offline Forms:</u></div>
                            <div> - Will offline forms be used to enter Station action data?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'removal-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'removal-check'
                                }, { label: 'No', value: 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y")) || showStationTeams == 0}
                                onChange={handleShowStationOfflineFormsRadioButtonChange}
                                value={showStationOfflineForms} />

                        </Col>

                    </Row>

                    <Row middle={"xs"} style={{ marginBottom: '16px' }}>
                        <Col xs={8}>
                            <div><u>P&C Team</u></div>
                            <div> - Does the scope of the project include any involvement from the P&C team?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'removal-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'removal-check',
                                }, { label: 'No', value: 0, disabled: showStationTeams == 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))}
                                onChange={handleShowPCTeamsRadioButtonChange}
                                value={showPCTeams} />

                        </Col>

                    </Row>
                    <Row middle={"xs"} style={{ marginBottom: '16px' }} className="question-row-even">
                <Col xs={8}>
                    <div><u>P&C Contractor</u></div>
                    <div>- Does this project have P&C Contractors?</div>
                </Col>
                <Col xs={4}>
                    <Radio.Group style={{ display: 'inline-flex' }} id={'pc-contractor-check'}
                    options={[{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }]}
                    disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y")) || showPCTeams == 0}
                    onChange={handlePCSelectChange}
                    value={tempProject.pcContractorSelected} />
                    {tempProject.pcContractorSelected === 1 &&
                    <span style={{ marginLeft: '10px' }}>
                        <b>{'Company: '}</b>{tempProject.pcContractor}
                        {(isCreatorOrAdministrator() && project.projectStatus !== "C") &&
                        <button className="btn btn-primary start-5" style={{ marginLeft: '10px' }}
                            onClick={handlePCEditChange}
                            disabled={!isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))}
                        >
                            Edit
                        </button>
                        }
                    </span>
                    }
                </Col>
                </Row>
                    <Row middle={"xs"} style={{ marginBottom: '16px' }}>
                        <Col xs={8}>
                            <div><u>P&C Offline Forms</u></div>
                            <div> - Will offline forms be used to enter P&C action data?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'removal-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'removal-check'
                                }, { label: 'No', value: 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y")) || showPCTeams == 0}
                                onChange={handleShowPCOfflineFormsRadioButtonChange}
                                value={showPCOfflineForms} />

                        </Col>

                    </Row>

                    <Row middle={"xs"} style={{ marginBottom: '16px' }} className="question-row-even">
                        <Col xs={8}>
                            <div><u>New Station</u></div>
                            <div> - Is this a Greenfield project?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'removal-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'removal-check'
                                }, { label: 'No', value: 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))}
                                onChange={handleShowNewStationsRadioButtonChange}
                                value={showNewStations} />

                        </Col>

                    </Row>


                    <Row middle={"xs"} style={{ marginBottom: '16px' }}>
                        <Col xs={8}>
                            <div><u>Hazardous Materials</u></div>
                            <div> - Are there any hazardous materials such as PCBs, Asbestos, Oil, or Arc Byproducts, etc. that will be disturbed during the job?</div>
                        </Col>
                        <Col xs={4}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'hazardous-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'hazardous-check'
                                }, { label: 'No', value: 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))}
                                onChange={handleShowHazardousMaterialsRadioButtonChange}
                                value={showHazardousMaterials} />
                            {(project.hazardousSelected && initialSelectedArray.length > 0) && project.hazardousSelected.length > 0 &&
                                <span style={{ marginLeft: '10px' }}>
                                    <b>{'Materials: '}</b>{initialSelectedArray.split(',').join(', ')}
                                    <button className="btn btn-primary start-5" style={{ marginLeft: '10px' }}
                                        onClick={onEditHazardousSelection}
                                        disabled={(project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))}>
                                        Edit
                                    </button>
                                </span>
                            }
                        </Col>
                    </Row>

                    <Row middle={"xs"} style={{ marginBottom: '16px' }} className="question-row-even">
                        <Col xs={8}>
                            <div><u>Asset Health</u></div>
                            <div> - Are any Asset Health Monitoring systems being installed or modified?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'removal-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'removal-check'
                                }, { label: 'No', value: 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))}
                                onChange={handleShowAssetHealthRadioButtonChange}
                                value={showAssetHealth} />

                        </Col>

                    </Row>

                    <Row middle={"xs"} style={{ marginBottom: '16px' }}>
                        <Col xs={8}>
                            <div><u>Distribution Automation</u></div>
                            <div> - Are any DA systems such as VVO, DACR, CVR, etc. being installed or modified?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'removal-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'removal-check'
                                }, { label: 'No', value: 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))}
                                onChange={handleShowDistributionAutomationRadioButtonChange}
                                value={showDistributionAutomation} />

                        </Col>

                    </Row>

                    <Row middle={"xs"} style={{ marginBottom: '16px' }} className="question-row-even">
                        <Col xs={8}>
                            <div><u>Drop In Control Module</u></div>
                            <div> - Will there be a new DICM or DICM Expansion installed?</div>
                        </Col>
                        <Col xs={2}>
                            <Radio.Group style={{ display: 'inline-flex' }} id={'removal-check'}
                                options={[{
                                    label: 'Yes',
                                    value: 1,
                                    id: 'removal-check'
                                }, { label: 'No', value: 0 }]}
                                disabled={spinnerOn || !isCreatorOrAdministrator() || (project.projectStatus === "C" || ((project.projectStatus === "R" || project.projectStatus === "A") && project.cipSelectLock === "Y"))}
                                onChange={handleShowDropInControlModuleRadioButtonChange}
                                value={showDropInControlModule} />

                        </Col>

                    </Row>
                    <br />
                    {
                        (isCreatorOrAdministrator() && (tempProject.projectStatus !== 'C')) &&
                        <MergeUnMergeProcess project={tempProject} history={history} />
                    }

                </Grid>

            </div>
        );
    }

    async function handleCommissioningStartDateChange(date) {
        let newDate = null;
        if (date) {
            newDate = date.format('MMMM DD, YYYY');
        }
        const newAttributes = {
            commisioningStartDate:
                newDate
        };
        const updatedProject = {
            ...tempProject,
            ...newAttributes
        };
        //console.log("updatedProject ", updatedProject);
        setSpinnerOn(true);
        let saveProject = await updateProjectDetails(updatedProject);
        setSpinnerOn(false);

        setTempProject(saveProject);
    }

    async function handleExpectedCloseDateChange(date) {
        let newDate = null;
        if (date) {
            newDate = date.format('MMMM DD, YYYY');
        }
        //console.log("prev date ", expectedCloseDate);
        if (!((newDate === null && tempProject.expectedCloseDate !== null) || (newDate !== null && tempProject.expectedCloseDate === null)
            || (newDate !== tempProject.expectedCloseDate))) {
            return;
        }
        if (newDate === null) {
            const newAttributes = {
                expectedCloseDate:
                    newDate
            };
            const updatedProject = {
                ...tempProject,
                ...newAttributes
            };
            setSpinnerOn(true);
            let saveProject = await updateProjectDetails(updatedProject);
            setSpinnerOn(false);
            //console.log("new date after ", saveProject.expectedCloseDate);
            setTempProject(saveProject);
            return;
        }
        if (newDate !== null) {
            await handleExpectedCloseDateEdit(newDate);
        }
    }
    function expectedCloseDateAlert(date) {

        let msg = `Expected Close Date can't be less than In-service Date + 45 Days.Please select a date greater than ${date.format('MMMM D, YYYY')}`;

        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Alert msg={msg} onClose={onClose} />
                );
            }
        });
    }
    async function handleExpectedCloseDateEdit(newDate) {
        // concerting  date in date format to compare 
        let selectedDate = dayjs(newDate)




        if (tempProject.inServiceDate && selectedDate.isBefore(defaultExpectedCloseDate)) {
            expectedCloseDateAlert(defaultExpectedCloseDate)
        } else {



            setSpinnerOn(true);
            const reasonCodes = await getReasonCodes();
            setSpinnerOn(false);

            confirmAlert({
                closeOnClickOutside: false,
                closeOnEscape: false,
                customUI: ({ onClose }) => {
                    return (
                        <ProjectReasonDialog reasonCodes={reasonCodes.data} onClose={onClose} newCloseDate={newDate} project={tempProject} setTempProject={setTempProject} />
                    );
                }
            });
        }
    }

    async function handlePCSelectChange(e) {
        if (e.target.value === 1) {
            handlePCEditChange();
        }
        else {
            const newAttributes = { pcContractorSelected: 0 };
            const updatedProject = { ...tempProject, ...newAttributes };
            setSpinnerOn(true);
            let saveProject = await updateProjectDetails(updatedProject);
            setSpinnerOn(false);
            setTempProject(saveProject);
            if(props.setCurrentProject) {
                props.setCurrentProject(saveProject);
            }
        }
    }

    async function handlePCEditChange() {
        setSpinnerOn(true);
        const contractors = await getPCContractors();
        setSpinnerOn(false);

        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <PCContractorDialog contractors={contractors.data} onClose={onClose} project={tempProject} setTempProject={handleTempProject} />
                );
            }
        });
    }

    async function handleRemovalRadioButtonChange(e) {
        const newAttributes = {
            showRemovalTasks:
                e.target.value
        };
        const updatedProject = {
            ...tempProject,
            ...newAttributes
        };
        if (project.projectStatus === 'D') {
            //console.log('updated project',updatedProject);
            setSpinnerOn(true);
            let saveProject = await updateProjectCIPRemovalDetails(updatedProject, 'REMOVAL');
            setSpinnerOn(false);
            //console.log('saved project',saveProject);
            setRemovalCheck(saveProject.showRemovalTasks);
        }
        else {
            if (e.target.value === 0) {
                setSpinnerOn(true);
                const response = await signedProjectTasks(project.id, 'REMOVAL');
                setSpinnerOn(false);
                if (response.isTasksSigned === "Y") {
                    tasksSignedAlert();
                    setRemovalCheck(1);
                    return;
                }
            }

            deleteAddTasksConfirmation("REMOVAL", e.target.value, updatedProject);
        }
    }

    async function handleSecurityRadioButtonChange(e) {
        const newAttributes = {
            showSecurityTasks:
                e.target.value
        };
        const updatedProject = {
            ...project,
            ...newAttributes
        };
        if (project.projectStatus === 'D') {
            setSpinnerOn(true);
            let saveProject = await updateProjectCIPRemovalDetails(updatedProject, 'SECURITY');
            setSpinnerOn(false);
            setSecurityCheck(saveProject.showSecurityTasks);
        }
        else {
            if (e.target.value === 0) {
                setSpinnerOn(true);
                const response = await signedProjectTasks(project.id, 'SECURITY');
                setSpinnerOn(false);
                if (response.isTasksSigned === "Y") {
                    tasksSignedAlert();
                    setSecurityCheck(1);
                    return;
                }
            }

            deleteAddTasksConfirmation("SECURITY", e.target.value, updatedProject);
        }
    }

  async function handleShowStationTeamsRadioButtonChange(e) {
    const newValue = e.target.value;
    //TCHEK-2894
    const newAttributes = {
        showStationTeams: newValue,
        ...(newValue == 0 && {
            showStationContractors: 0,
            showStationOfflineForms: 0,
            ...(showPCTeams == 0 && {
                showPCTeams: 1,
                pcContractorSelected: null,
                pcContractor: null,
                showPCOfflineForms: null
            })
        }),
        ...(newValue != 0 && {
            showStationContractors: null,
            showStationOfflineForms: null
        })
        //ENDTCHEK-2894
    };
        const updatedProject = {
            ...project,
            ...newAttributes
        };
    if (project.projectStatus === 'D' || project.projectStatus === 'R' || project.projectStatus === 'A') {
        setSpinnerOn(true);
        let saveProject = await updateProjectDetails(updatedProject);
        setSpinnerOn(false);
        //TCHEK-2894
        if (newValue == 0) {
            setShowStationContractors(saveProject.showStationContractors);
            setShowStationOfflineForms(saveProject.showStationOfflineForms);
            if (showPCTeams == 0) {
                setShowPCOfflineForms(null);
                setTempProject(prev => ({ ...prev, pcContractorSelected: null, pcContractor: null }));
            }
        } else {
            setShowStationContractors(null);
            setShowStationOfflineForms(null);
        }
        //ENDTCHEK-2894
        setShowStationTeams(saveProject.showStationTeams);
        setShowPCTeams(saveProject.showPCTeams);
        if(props.setCurrentProject) {
            props.setCurrentProject(saveProject);
        }
    }
}

    async function handleShowStationContractorsRadioButtonChange(e) {
        const newAttributes = {
            showStationContractors:
                e.target.value
        };
        const updatedProject = {
            ...project,
            ...newAttributes
        };
        if (project.projectStatus === 'D' || project.projectStatus === 'R' || project.projectStatus === 'A') {
            setSpinnerOn(true);
            let saveProject = await updateProjectDetails(updatedProject);
            setSpinnerOn(false);
            setShowStationContractors(saveProject.showStationContractors);
            if(props.setCurrentProject) {
            props.setCurrentProject(saveProject);
        }
        }
    }

    async function handleShowStationOfflineFormsRadioButtonChange(e) {
        const newAttributes = {
            showStationOfflineForms:
                e.target.value
        };
        const updatedProject = {
            ...project,
            ...newAttributes
        };
        if (project.projectStatus === 'D' || project.projectStatus === 'R' || project.projectStatus === 'A') {
            setSpinnerOn(true);
            let saveProject = await updateProjectDetails(updatedProject);
            setSpinnerOn(false);
            setShowStationOfflineForms(saveProject.showStationOfflineForms);
            if(props.setCurrentProject) {
            props.setCurrentProject(saveProject);
        }
        }
    }

    async function handleShowPCTeamsRadioButtonChange(e) {
    const newValue = e.target.value;
    const newAttributes = {
        showPCTeams: newValue,
        ...(newValue == 0 && {
            pcContractorSelected: 0,
            showPCOfflineForms: 0,
            ...(showStationTeams == 0 && {
                showStationTeams: 1,
                showStationContractors: null,
                showStationOfflineForms: null
            })
        }),
        ...(newValue != 0 && {
            pcContractorSelected: null,
            pcContractor: null,
            showPCOfflineForms: null
        })
    };
        const updatedProject = {
            ...project,
            ...newAttributes
        };
    if (project.projectStatus === 'D' || project.projectStatus === 'R' || project.projectStatus === 'A') {
        setSpinnerOn(true);
        let saveProject = await updateProjectDetails(updatedProject);
        setSpinnerOn(false);
        setShowPCTeams(saveProject.showPCTeams);
        if (newValue == 0) {
            setShowPCOfflineForms(saveProject.showPCOfflineForms);
            setTempProject(prev => ({ ...prev, pcContractorSelected: saveProject.pcContractorSelected, pcContractor: saveProject.pcContractor }));
            if (showStationTeams == 0) {
                setShowStationTeams(1);
                setShowStationContractors(null);
                setShowStationOfflineForms(null);
            }
        } else {
            setShowPCOfflineForms(null);
            setTempProject(prev => ({ ...prev, pcContractorSelected: null, pcContractor: null }));
        }
        if(props.setCurrentProject) {
            props.setCurrentProject(saveProject);
        }
    }
}

    async function handleShowPCOfflineFormsRadioButtonChange(e) {
        const newAttributes = {
            showPCOfflineForms:
                e.target.value
        };
        const updatedProject = {
            ...tempProject,
            ...newAttributes
        };
        if (project.projectStatus === 'D' || project.projectStatus === 'R' || project.projectStatus === 'A') {
            setSpinnerOn(true);
            let saveProject = await updateProjectDetails(updatedProject);
            setSpinnerOn(false);
            setShowPCOfflineForms(saveProject.showPCOfflineForms);
            setTempProject(saveProject);
            if(props.setCurrentProject) {
            props.setCurrentProject(saveProject);
        }
        }
    }

    async function handleShowNewStationsRadioButtonChange(e) {
        const newAttributes = {
            showNewStations:
                e.target.value
        };
        const updatedProject = {
            ...project,
            ...newAttributes
        };
        if (project.projectStatus === 'D' || project.projectStatus === 'R' || project.projectStatus === 'A') {
            setSpinnerOn(true);
            let saveProject = await updateProjectDetails(updatedProject);
            setSpinnerOn(false);
            setShowNewStations(saveProject.showNewStations);
            if(props.setCurrentProject) {
            props.setCurrentProject(saveProject);
        }
        }
    }

    async function onEditHazardousSelection(e) {
        fetchData();
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <HazardousSelectionDialog project={project} initialSelectedArray={project.hazardousSelected || initialSelectedArray}
                    onClose={async (wasSaved) => {
                        const hasExistingSelection = project.hazardousSelected && project.hazardousSelected.length > 0;
                        if (!wasSaved && !hasExistingSelection) {
                            setShowHazardousMaterials(0);
                            const updateProject = { ...project, showHazardousMaterials: 0 };
                            let saveProject = await updateProjectDetails(updateProject);
                            setCurrentProject(saveProject);
                            await saveHazardousMaterials('');
                        }
                        onClose();
                    }}
                    onSave={async (newValue) => {setShowHazardousMaterials(1); await handleSave(newValue); }} />
                );
            }
        });
    }

    async function handleShowHazardousMaterialsRadioButtonChange(e) {

        const newAttributes = {
            showHazardousMaterials:
                e.target.value
        };
        const updatedProject = {
            ...project,
            ...newAttributes
        };
        if (project.projectStatus === 'D' || project.projectStatus === 'R' || project.projectStatus === 'A') {
            setSpinnerOn(true);
            let saveProject = await updateProjectDetails(updatedProject);
            setSpinnerOn(false);
            setShowHazardousMaterials(saveProject.showHazardousMaterials);
            setCurrentProject(saveProject);

            if (e.target.value == 1) {
                setSelectedValueString('');
                onEditHazardousSelection(e);
                return;
            }

            if (e.target.value === 0) {
                setSelectedValueString('');
                await saveHazardousMaterials('');
            }
        }

    }

    async function handleShowAssetHealthRadioButtonChange(e) {
        const newAttributes = {
            showAssetHealth:
                e.target.value
        };
        const updatedProject = {
            ...project,
            ...newAttributes
        };
        if (project.projectStatus === 'D' || project.projectStatus === 'R' || project.projectStatus === 'A') {
            setSpinnerOn(true);
            let saveProject = await updateProjectDetails(updatedProject);
            setSpinnerOn(false);
            setShowAssetHealth(saveProject.showAssetHealth);
            setCurrentProject(saveProject);
        }
    }

    async function handleShowDistributionAutomationRadioButtonChange(e) {
        const newAttributes = {
            showDistributionAutomation:
                e.target.value
        };
        const updatedProject = {
            ...project,
            ...newAttributes
        };
        if (project.projectStatus === 'D' || project.projectStatus === 'R' || project.projectStatus === 'A') {
            setSpinnerOn(true);
            let saveProject = await updateProjectDetails(updatedProject);
            setSpinnerOn(false);
            setShowDistributionAutomation(saveProject.showDistributionAutomation);
            setCurrentProject(saveProject);
        }
    }

    async function handleShowDropInControlModuleRadioButtonChange(e) {
        const newAttributes = {
            showDropInControlModule:
                e.target.value
        };
        const updatedProject = {
            ...project,
            ...newAttributes
        };
        if (project.projectStatus === 'D' || project.projectStatus === 'R' || project.projectStatus === 'A') {
            setSpinnerOn(true);
            let saveProject = await updateProjectDetails(updatedProject);
            setSpinnerOn(false);
            setShowDropInControlModule(saveProject.showDropInControlModule);
            setCurrentProject(saveProject);
        }
    }

    function tasksSignedAlert() {
        let msg = "There are completed tasks in this section. Please review and undo tasks prior to removing this section.";
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Alert msg={msg} onClose={onClose} />
                );
            }
        });
    }

    async function deleteAddTasksConfirmation(taskType, action, updatedProject) {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="react-confirm-alert-body">
                        <h2>{(action === 0) ? 'Remove' : 'Add'} Section</h2>
                        <br />
                        <p>Are you sure you want to {(action === 0) ? 'delete' : 'add'} this section? </p>
                        <br />
                        <div className="btn start-2">
                            <button
                                className="btn btn-primary start-5"
                                onClick={async () => {
                                    // remove or add section
                                    setSpinnerOn(true);
                                    let saveProject = await updateProjectCIPRemovalDetails(updatedProject, taskType);
                                    setSpinnerOn(false);
                                    if (taskType === 'REMOVAL')
                                        setRemovalCheck(saveProject.showRemovalTasks);
                                    else if (taskType === 'SECURITY')
                                        setSecurityCheck(saveProject.showSecurityTasks);
                                    else
                                        setShowStationTeams(saveProject.showStationTeams)
                                    onClose();
                                }}>
                                {"  "}
                                Yes
                            </button>
                            {" "}
                            <button className="btn btn-primary start-5"
                                onClick={() => {
                                    if (taskType === 'REMOVAL')
                                        setRemovalCheck(updatedProject.showRemovalTasks === 1 ? 0 : 1);
                                    else
                                        setSecurityCheck(updatedProject.showSecurityTasks === 1 ? 0 : 1);
                                    onClose();
                                }} >
                                No
                            </button>
                        </div>
                    </div>
                );
            }
        });
    }

    async function saveHazardousMaterials(selectedHazardous) {
        let response = await updateProjectDetailsHazardousMaterials(project, selectedHazardous);
        let saveProject = response.data;
        setSelectedValueString(selectedHazardous);
        setCurrentProject({ ...project, ...saveProject});
    }

}

export default withRouter(ProjectDetailsWrapper);
